export const services = [
  {
    id: "residential",
    code: "01",
    name: "Residential",
    summary:
      "New homes, ADUs, additions, and remodels. From schematic sketch to final punch list.",
    items: [
      "Custom single-family homes",
      "Accessory dwelling units (ADUs)",
      "Whole-home remodels & additions",
      "Cabins, guesthouses, and outbuildings",
    ],
  },
  {
    id: "commercial",
    code: "02",
    name: "Commercial",
    summary:
      "Community-scale commercial work — places that have to look right on the block and work hard for the people who run them.",
    items: [
      "Small-scale mixed-use",
      "Retail and tasting rooms",
      "Office and creative workspace",
      "Tenant improvements",
    ],
  },
  {
    id: "design-planning",
    code: "03",
    name: "Design & Planning",
    summary:
      "Full-scope architectural services from feasibility through construction administration. Drawings detailed enough that the builder doesn't have to guess.",
    items: [
      "Feasibility & site analysis",
      "Schematic design & 3D modeling",
      "Permit & construction documents",
      "Construction administration",
    ],
  },
];

export const process = [
  {
    code: "01",
    name: "Listen",
    body: "A long conversation about how you actually live, work, and use the site you're building on. The brief gets written together.",
  },
  {
    code: "02",
    name: "Sketch",
    body: "Schematic massing, section studies, and rough 3D — fast, cheap, and meant to be argued with. We test ten ideas to find one.",
  },
  {
    code: "03",
    name: "Detail",
    body: "Design development through full construction documents. Materials selected, details drawn, structure coordinated, budget verified.",
  },
  {
    code: "04",
    name: "Build",
    body: "Site visits, RFI responses, submittal review. Hands-on construction admin so what gets built is what you signed off on.",
  },
];
